import { useMutation } from 'react-query'

import { APIError } from '../../../../../../../utils'
import { useDefaultTradeName } from '../../../../../hooks/useDefaultTradeName'
import { uploadZervantInvoiceLogo, type UploadZervantInvoiceLogoResponse } from '../../../query-api'

interface UseUploadZervantInvoiceLogoProps {
  onError?: (error?: APIError) => void
  onSuccess?: (data: UploadZervantInvoiceLogoResponse) => void
}

export const useUploadZervantInvoiceLogo = (props?: UseUploadZervantInvoiceLogoProps) => {
  const { onError, onSuccess } = props || {}
  const { defaultTradeName } = useDefaultTradeName()

  const {
    mutate: upload,
    isLoading: isProcessing,
    ...rest
  } = useMutation<UploadZervantInvoiceLogoResponse, APIError, File>(
    (file: File) => {
      const formData = new FormData()
      formData.append('file', file, file.name)

      return uploadZervantInvoiceLogo(formData, defaultTradeName?._id || '')
    },
    {
      onError,
      onSuccess: (data) => {
        onSuccess?.(data)
      },
    },
  )

  return { upload, isProcessing, ...rest }
}
